export const handleChangeHeader = (headerName: string) => {
	const formattedHeaderName = headerName.replace(/_/g, " ");
	return formattedHeaderName.toUpperCase();
};
